/* es6-promise/auto.js */ function _(require, module, exports) {
    module.exports = require(101) /* ./ */.polyfill();
}
